import {
  Action_GetDMGiaCong,
  Action_GetDMGiaCongSuccess,
  Action_GetGiaCongByNhomSanPham,
  Action_GetGiaCongByNhomSanPhamSuccess,
  Action_SaveGiaCongByNhomSanPham,
  Action_SaveGiaCongByNhomSanPhamSuccess,
  Action_SaveGiaCongByNhomSanPhamFailed,
  Action_DeleteGiaCongByNhomSanPham,
  Action_DeleteGiaCongByNhomSanPhamSuccess,
  Action_DeleteGiaCongByNhomSanPhamFailed,
} from "actions/DanhMuc/DanhMucGiaCong/actionTypes";
import Config from "constants/configs";

const initialState = {
  objGiaCong: {},
  objGiaCongByNhomSanPham: {},
  sGetGiaCongByNhomSanPham: Config.sTrangThaiRequestAPI.ChuaGoi,
  sDeleteGiaCongByNhomSanPham: Config.sTrangThaiRequestAPI.ChuaGoi,
  sSaveGiaCongByNhomSanPham: Config.sTrangThaiRequestAPI.ChuaGoi,
  isProgress : false,
};
////////////////////////
const Reducer_GetDMGiaCong = (state, action) => ({
  ...state,
  isProgress: true,
});
const Reducer_GetDMGiaCongSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objGiaCong: action.payload,
    isProgress: false,
  };
};
////////////////////////
const Reducer_GetGiaCongByNhomSanPham = (state, action) => ({
  ...state,
  isProgress: true,
  sGetGiaCongByNhomSanPham: Config.sTrangThaiRequestAPI.DangGoi,
});
const Reducer_GetGiaCongByNhomSanPhamSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isProgress: false,
    objGiaCongByNhomSanPham: action.payload,
    sGetGiaCongByNhomSanPham: Config.sTrangThaiRequestAPI.Success,
  };
};
////////////////////////
const Reducer_SaveGiaCongByNhomSanPham = (state, action) => ({
  ...state,
  isProgress: true,
  sSaveGiaCongByNhomSanPham: Config.sTrangThaiRequestAPI.DangGoi,
});
const Reducer_SaveGiaCongByNhomSanPhamSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isProgress: false,
    sSaveGiaCongByNhomSanPham: Config.sTrangThaiRequestAPI.Success,
  };
};
const Reducer_SaveGiaCongByNhomSanPhamFailed = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isProgress: false,
    sSaveGiaCongByNhomSanPham: Config.sTrangThaiRequestAPI.Failed,
  };
};
////////////////////////
const Reducer_DeleteGiaCongByNhomSanPham = (state, action) => ({
  ...state,
  isProgress: true,
  sDeleteGiaCongByNhomSanPham: Config.sTrangThaiRequestAPI.DangGoi,
});
const Reducer_DeleteGiaCongByNhomSanPhamSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isProgress: false,
    sDeleteGiaCongByNhomSanPham: Config.sTrangThaiRequestAPI.Success,
  };
};
const Reducer_DeleteGiaCongByNhomSanPhamFailed = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isProgress: false,
    sDeleteGiaCongByNhomSanPham: Config.sTrangThaiRequestAPI.Failed,
  };
};


// end 
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case Action_GetDMGiaCong:
      return Reducer_GetDMGiaCong(state, action);
    case Action_GetDMGiaCongSuccess:
      return Reducer_GetDMGiaCongSuccess(state, action);

    case Action_GetGiaCongByNhomSanPham:
      return Reducer_GetGiaCongByNhomSanPham(state, action);
    case Action_GetGiaCongByNhomSanPhamSuccess:
      return Reducer_GetGiaCongByNhomSanPhamSuccess(state, action);

    case Action_SaveGiaCongByNhomSanPham:
      return Reducer_SaveGiaCongByNhomSanPham(state, action);
    case Action_SaveGiaCongByNhomSanPhamSuccess:
      return Reducer_SaveGiaCongByNhomSanPhamSuccess(state, action);
    case Action_SaveGiaCongByNhomSanPhamFailed:
      return Reducer_SaveGiaCongByNhomSanPhamFailed(state, action);

    case Action_DeleteGiaCongByNhomSanPham:
      return Reducer_DeleteGiaCongByNhomSanPham(state, action);
    case Action_DeleteGiaCongByNhomSanPhamSuccess:
      return Reducer_DeleteGiaCongByNhomSanPhamSuccess(state, action);
    case Action_DeleteGiaCongByNhomSanPhamFailed:
      return Reducer_DeleteGiaCongByNhomSanPhamFailed(state, action);
    default:
      return state;
  }
};
export default authReducer;
